import store from "@store";
import { eventIsDealerOnly, eventIsEnd, eventIsStart } from "@utils/zerone-event";

/**
 * 狀態模式
 * @param inProgress
 * @param isFinished
 * @param canApply
 * @param canRegistration
 * @param registrationStartDate
 * @param registrationEndDate
 * @param type
 * @param canRegisterGroup
 * @param isFull
 * @param regEndDateExpired
 * @param isSession,
 * @param isApply
 * @returns {string|string}
 */
export function eventStatusMode({
  inProgress,
  isFinished,
  canApply,
  canRegistration = 1,
  registrationStartDate,
  registrationEndDate,
  type,
  canRegisterGroup = 1,
  sessionsEnd,
  isFull = 0,
  regEndDateExpired = 0,
  isSession = 0,
  isApply = 0,
} = {}) {
  const isStart = eventIsStart(registrationStartDate);
  const isEnd = eventIsEnd(registrationEndDate);
  const isDealerOnly = eventIsDealerOnly({ canRegisterGroup });
  const memberGroupId = store.state.auth.currentMember?.groupId;
  const isLoggedIn = store.getters['auth/loggedIn'];
  if (inProgress && !isApply) {
    return type === 'online'
      ? 'IN_LIVE'
      : 'IN_PROGRESS'
  } else if (!isStart) {
    return 'NOT_REGISTRATION_START'
  } else if ((isSession && regEndDateExpired) || isEnd) {
    if (isFinished) {
      return 'IS_ACTION_END'
    } else {
      return 'IS_REGISTRATION_END'
    }
  } else if (type === 'online' && !isEnd && isFinished) {
    return 'CAN_REPLAY'
  } else if (!canRegistration) {
    return 'CAN_NOT_REGISTRATION'
  } else if (canApply === 3) {
    return 'NOT_YET_OPEN'
  } else if (canApply === 2 && isFull === 2) {
    return 'CAN_WAITING'
  } else if ((isSession && isFull) || !canApply) {
    return 'CAN_NOT_APPLY'
  } else if (isDealerOnly && isLoggedIn && memberGroupId !== 6) {
    return 'DEALER_ONLY'
  } else if (canApply && canApply !== 2) {
    return 'CAN_APPLY'
  }
}

/**
 * 預設狀態物件
 * @param statusMode
 * @returns {{mode: string, display: boolean, disabled: boolean, title: string, class: string}}
 */
export function eventDefaultStatusItem(statusMode) {
  switch (statusMode) {
    case 'DEALER_ONLY':
      return {
        mode: 'DEALER_ONLY',
        title: '無法報名',
        class: 'isStyleGrayLight isSmall isRadius',
        disabled: true,
        display: true
      };
    case 'IN_LIVE':
      return {
        mode: 'IN_LIVE',
        title: '直播中',
        class: 'isStyleDanger isSmall isRadius isOutline3',
        disabled: false,
        display: true
      };
    case 'IN_PROGRESS':
      return {
        mode: 'IN_PROGRESS',
        title: '進行中',
        class: 'isStylePrimary isSmall isRadius',
        disabled: false,
        display: true
      };
    case 'NOT_REGISTRATION_START':
      return {
        mode: 'NOT_REGISTRATION_START',
        title: '尚未開放報名',
        class: 'isStyleGrayLight isSmall isRadius',
        disabled: true,
        display: true
      };
    case 'IS_REGISTRATION_END':
      return {
        mode: 'IS_REGISTRATION_END',
        title: '報名截止',
        class: 'isStyleGrayLight isSmall isRadius',
        disabled: true,
        display: true
      };
    case 'IS_ACTION_END':
      return {
        mode: 'IS_ACTION_END',
        title: '活動結束',
        class: 'isStyleGrayLight isSmall isRadius',
        disabled: true,
        display: true
      };
    case 'CAN_NOT_REGISTRATION':
      return {
        mode: 'CAN_NOT_REGISTRATION',
        title: '不可報名',
        class: 'isStyleGrayLight isSmall isRadius',
        disabled: true,
        display: true
      };
    case 'CAN_NOT_APPLY':
      return {
        mode: 'CAN_NOT_APPLY',
        title: '已額滿',
        class: 'isStyleGrayLight isSmall isRadius',
        disabled: true,
        display: true
      };
    case 'NOT_YET_OPEN':
      return {
        mode: 'NOT_YET_OPEN',
        title: '尚未開放報名',
        class: 'isStyleGrayLight isSmall isRadius',
        disabled: true,
        display: true
      };
    case 'CAN_REPLAY':
      return {
        mode: 'CAN_APPLY',
        title: '精彩回放',
        class: 'isStylePrimary isSmall isRadius isOutline2',
        disabled: false,
        display: true
      };
    case 'CAN_APPLY':
      return {
        mode: 'CAN_APPLY',
        title: '即刻報名',
        class: 'isStylePrimary isSmall isRadius isOutline2',
        disabled: false,
        display: true
      };
    case 'CAN_WAITING':
    default:
      return {
        mode: 'CAN_WAITING',
        title: '報名候補',
        class: 'isStylePrimary isSmall isRadius isOutline2',
        disabled: false,
        display: true
      };
  }
}

/**
 * 列表按鈕狀態物件
 * @param inProgress
 * @param isFinished
 * @param canApply
 * @param canRegistration
 * @param registrationStartDate
 * @param registrationEndDate
 * @param type
 * @param regEndDateExpired
*  @param canRegisterGroup
 * @param isFull
 * @param isSession
 * @returns {{mode: string, display: boolean, disabled: boolean, title: string, class: string}|{mode: string, display:
 *   boolean, disabled: boolean, title: string, class: string}|{mode: string, display: boolean, disabled: boolean,
 *   title: string, class: string}|{mode: string, display: boolean, disabled: boolean, title: string, class:
 *   string}|{mode: string, display: boolean, disabled: boolean, title: string, class: string}|{mode: string, display:
 *   boolean, disabled: boolean, title: string, class: string}|{mode: string, display: boolean, disabled: boolean,
 *   title: string, class: string}|{mode: string, display: boolean, disabled: boolean, title: string, class: string}}
 */
export function eventListButtonStatusItem({
  inProgress,
  isFinished,
  canApply,
  canRegistration = 1,
  registrationStartDate,
  registrationEndDate,
  type,
  canRegisterGroup = 1,
  isFull = 0,
  regEndDateExpired = 0,
  isSession = 0
} = {}) {
  const statusMode = eventStatusMode({
    inProgress,
    isFinished,
    canApply,
    canRegistration,
    registrationStartDate,
    registrationEndDate,
    type,
    canRegisterGroup,
    regEndDateExpired,
    isFull,
    isSession
  });
  return eventDefaultStatusItem(statusMode);
}

/**
 * 場次按鈕狀態物件
 * @param inProgress
 * @param isFinished
 * @param canApply
 * @param canRegistration
 * @param registrationStartDate
 * @param registrationEndDate
 * @param type
 * @param canRegisterGroup
 * @param sessionsEnd
 * @param isFull
 * @param regEndDateExpired 
 * @param isSession
 * @param isApply
 * @returns {{mode: (string), display: boolean, disabled: (boolean), title: (string), class: (string)}|{mode: string,
 *   display: boolean, disabled: boolean, title: string, class: string}|{mode: string, display: boolean, disabled:
 *   boolean, title: string, class: string}|{mode: string, display: boolean, disabled: boolean, title: string, class:
 *   string}|{mode: string, display: boolean, disabled: boolean, title: string, class: string}|{mode: string, display:
 *   boolean, disabled: boolean, title: string, class: string}|{mode: string, display: boolean, disabled: boolean,
 *   title: string, class: string}|{mode: string, display: boolean, disabled: boolean, title: string, class:
 *   string}|{mode: string, display: boolean, disabled: boolean, title: string, class: string}}
 */
export function eventSessionButtonStatusItem({
  inProgress,
  isFinished,
  canApply,
  canRegistration = 1,
  registrationStartDate,
  registrationEndDate,
  type,
  canRegisterGroup = 1,
  sessionsEnd,
  isFull = 0,
  regEndDateExpired = 0,
  isSession = 0,
  isApply = 0,
} = {}) {
  const statusMode = eventStatusMode({
    inProgress,
    isFinished,
    canApply,
    canRegistration,
    registrationStartDate,
    registrationEndDate,
    type,
    canRegisterGroup,
    sessionsEnd,
    isFull,
    regEndDateExpired,
    isSession,
    isApply
  });

  const defaultStatusItem = eventDefaultStatusItem(statusMode);

  switch (statusMode) {
    case 'DEALER_ONLY':
      return {
        ...defaultStatusItem,
        display: false
      };
    case 'CAN_NOT_REGISTRATION':
      return {
        ...defaultStatusItem,
        display: false
      };
    default:
      return defaultStatusItem;
  }
}

/**
 * 場次大按鈕狀態物件
 * @param inProgress
 * @param canApply
 * @param canRegistration
 * @param registrationStartDate
 * @param registrationEndDate
 * @param type
 * @param canRegisterGroup
 * @returns {{defaultStatusItem: ({mode: string, display: boolean, disabled: boolean, title: string, class:
 *   string}|{mode: string, display: boolean, disabled: boolean, title: string, class: string}|{mode: string, display:
 *   boolean, disabled: boolean, title: string, class: string}|{mode: string, display: boolean, disabled: boolean,
 *   title: string, class: string}|{mode: string, display: boolean, disabled: boolean, title: string, class:
 *   string}|{mode: string, display: boolean, disabled: boolean, title: string, class: string}|{mode: string, display:
 *   boolean, disabled: boolean, title: string, class: string}|{mode: string, display: boolean, disabled: boolean,
 *   title: string, class: string}), display: boolean}|{mode: (string), display: boolean, disabled: (boolean), title:
 *   string, class: (string)}|{mode: (string), display: boolean, disabled: (boolean), title: (string), class: string}}
 */
export function eventSessionBigButtonStatusItem({
  inProgress,
  canApply,
  canRegistration = 1,
  registrationStartDate,
  registrationEndDate,
  type,
  canRegisterGroup = 1,
  isFull,
  regEndDateExpired,
  isFinished
} = {}) {
  const statusMode = eventStatusMode({
    inProgress,
    canApply,
    canRegistration,
    registrationStartDate,
    registrationEndDate,
    type,
    canRegisterGroup,
    isFull,
    regEndDateExpired,
    isFinished
  });

  const defaultStatusItem = eventDefaultStatusItem(statusMode);
  switch (statusMode) {
    case 'DEALER_ONLY':
      return {
        ...defaultStatusItem,
        title: '經銷商限定，無法報名',
      };
    case 'CAN_APPLY':
    case 'CAN_REPLAY':
      return {
        ...defaultStatusItem,
        class: 'isStylePrimary',
      };
    case 'CAN_WAITING':
      return {
        ...defaultStatusItem,
        class: 'isStylePrimary',
      };
    default:
      return {
        defaultStatusItem,
        display: false
      };
  }
}

/**
 * 標籤狀態物件
 * @param inProgress
 * @param isFinished
 * @param canApply
 * @param registrationStartDate
 * @param registrationEndDate
 * @param type
 * @returns {{display: (boolean|*), disabled: (boolean|*), title: (string|*), class: (string|*)}}
 */
export function eventTagStatusItem({
  inProgress,
  isFinished,
  canApply,
  registrationStartDate,
  registrationEndDate,
  type,
} = {}) {
  const statusMode = eventStatusMode({
    inProgress,
    isFinished,
    canApply,
    registrationStartDate,
    registrationEndDate,
    type,
  });

  const defaultStatusItem = eventDefaultStatusItem(statusMode);
  switch (statusMode) {
    case 'IN_PROGRESS':
      return {
        ...defaultStatusItem,
        class: type === 'online'
          ? 'isStyleDanger'
          : 'isStylePrimary',
      };
    case 'NOT_REGISTRATION_START':
      return {
        ...defaultStatusItem,
        class: 'isStyleWarning',
      };
    case 'IS_REGISTRATION_END':
      return {
        ...defaultStatusItem,
        class: 'isStyleGray',
      };
    case 'IS_ACTION_END':
      return {
        ...defaultStatusItem,
        class: 'isStyleGray',
      };
    case 'CAN_NOT_APPLY':
      return {
        ...defaultStatusItem,
        class: 'isStylePurple',
      };
    case 'NOT_YET_OPEN':
      return {
        ...defaultStatusItem,
        class: 'isStylePurple',
      };
    case 'CAN_APPLY':
      return {
        ...defaultStatusItem,
        title: '開放報名',
        class: 'isStylePrimary',
      };
    case 'CAN_WAITING':
      return {
        ...defaultStatusItem,
        title: '開放候補',
        class: 'isStylePrimary',
      };
    default:
      return defaultStatusItem;
  }
}
// 即將直播 直播中 直播結束
